/** @jsxImportSource @emotion/react */

import HelmetCustom from "components/common/HelmetCustom";
import MDrawer from "components/mobile/MDrawer";
import { userPath } from "constants/path";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { MForgotPassByPhoneStyle } from "./index.style";

const MForgotPassByPhone = () => {
  const navigate = useNavigate();

  const [isOpenDraw, setIsOpenDraw] = useState<boolean>(true);

  const handleClose = () => {
    setIsOpenDraw(false);
    navigate(userPath);
  };

  return (
    <div css={MForgotPassByPhoneStyle.self}>
      <HelmetCustom title="Quên" />
      <MDrawer title={"Quên"} isOpen={isOpenDraw} onClose={handleClose}>
        <div css={MForgotPassByPhoneStyle.content}>
          <span>
            Vui lòng liên hệ bộ phận chăm sóc khách hàng để được hỗ trợ
          </span>
        </div>
      </MDrawer>
    </div>
  );
};

export default MForgotPassByPhone;
